export function normalizePhone(value:string):string|null {
  const compact=value.trim().replace(/[\s()-]/g,'');
  if(/^\+\d{8,15}$/.test(compact)) return compact;
  if(/^0\d{9,10}$/.test(compact)) return `+81${compact.slice(1)}`;
  return null;
}

export function displayPhone(value:string):string {
  if(value.startsWith('+81')) return `0${value.slice(3)}`;
  return value;
}
